import { ApiEndPoints, NetworkManager } from "../network";

export class AshaServices {
  static getAllAshas = (taluk = "") => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.ashas,
      // params: { page, pages, limit, taluk },
    });
  };

  static getAshaByAshaBlockId = (ashaBlockId) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.getAshaByAshaBlockId + ashaBlockId,
      // data: { ...id },
    });
  };
  
  static getAshaByTalukId = (talukId) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.getAshaByTalukId + talukId,
      params: {talukId },
    });
  };

  static getAshaByPhcId = (phcId) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.getAshaByPhcId + phcId,
      // data: { ...id },
    });
  };

  static addAsha = (asha) => {
    return NetworkManager.getInstance().appRequest({
      method: "post",
      url: ApiEndPoints.ashas,
      data: { ...asha },
    });
  };

  static updateAshas = (asha) => {
    return NetworkManager.getInstance().appRequest({
      method: "put",
      url: ApiEndPoints.ashas,
      data: { ...asha },
    });
  };

  static deleteAsha = (id) => {
    return NetworkManager.getInstance().appRequest({
      method: "delete",
      url: ApiEndPoints.ashas + "/" + id,
      data: { ...id },
    });
  };

  static bulkAddAsha = (data) => {
    return NetworkManager.getInstance().appRequest({
      method: "post",
      url: ApiEndPoints.ashas + "/uploadExcel",
      data: data,
    });
  };

  static getAshaDailyReport = () => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.getAshaDailyReport,
    });
  };

  static getAshaDailyReportByDateRange = (fromDate, toDate) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.getAshaDailyReportByDateRange,
      params: { fromDate, toDate },
    });
  };

  static getDashBoardDataSuperAdmin = () => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.ashas + "/dashboardSuperAdmin",
    });
  };

  static getDashBoardDataTaluk = (talukId) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.ashas + "/dashboardTaluk/" + talukId,
    });
  };

  static getDashBoardDataPhc = (phcId) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.ashas + "/dashboardPhc/" + phcId,
    });
  };

  static getDashBoardDataAshaBlock = (ashaBlockId) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.ashas + "/dashboardAshaBlock/" + ashaBlockId,
    });
  };
}
